import { render, staticRenderFns } from "./ControlDoctor.vue?vue&type=template&id=9c6ec30a&scoped=true"
import script from "./ControlDoctor.vue?vue&type=script&lang=js"
export * from "./ControlDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6ec30a",
  null
  
)

export default component.exports